const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20scene%20with%20dramatic%20warm%20golden%20lighting%2C%20abstract%20urban%20nightscape%20with%20neon%20accents%2C%20film%20noir%20aesthetic%2C%20rich%20contrast%20between%20amber%20and%20shadow%2C%20cinematic%20composition%2C%20no%20text%20no%20faces&width=800&height=600&seq=card-movie-01&orientation=landscape',
    title: '星际迷航：新纪元',
    tag: '科幻巨制',
    rating: '9.2',
    desc: '人类探索未知星域的壮丽史诗，视觉奇观震撼人心',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Atmospheric%20martial%20arts%20film%20scene%20in%20ancient%20Chinese%20setting%20with%20misty%20mountains%20and%20bamboo%20forest%2C%20warm%20sepia%20tones%2C%20soft%20diffused%20lighting%2C%20elegant%20composition%2C%20no%20text%20no%20faces&width=800&height=600&seq=card-movie-02&orientation=landscape',
    title: '夜雨江湖',
    tag: '武侠经典',
    rating: '8.9',
    desc: '江湖恩怨情仇，一剑一酒走天涯的武侠世界',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20abyss%20cinematic%20scene%20with%20mysterious%20blue%20and%20teal%20underwater%20lighting%2C%20ancient%20ruins%20submerged%2C%20atmospheric%20rays%20of%20light%20penetrating%20water%2C%20cinematic%20wide%20shot%2C%20no%20text%20no%20faces&width=800&height=600&seq=card-movie-03&orientation=landscape',
    title: '深海迷城',
    tag: '冒险悬疑',
    rating: '8.7',
    desc: '深海之下的失落文明，一场惊心动魄的探险之旅',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20forest%20at%20twilight%20with%20fog%20rolling%20through%20trees%2C%20warm%20amber%20moonlight%20filtering%20through%20branches%2C%20thriller%20atmosphere%2C%20cinematic%20suspense%20composition%2C%20no%20text%20no%20faces&width=800&height=600&seq=card-movie-04&orientation=landscape',
    title: '荒野追凶',
    tag: '犯罪惊悚',
    rating: '8.5',
    desc: '荒野追踪，真相扑朔迷离，全程无尿点的悬疑佳作',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Magical%20moonlit%20ancient%20Chinese%20garden%20with%20cherry%20blossoms%20and%20lanterns%2C%20fantasy%20atmosphere%20with%20soft%20ethereal%20glow%2C%20warm%20golden%20and%20silver%20lighting%2C%20dreamy%20composition%2C%20no%20text%20no%20faces&width=800&height=600&seq=card-movie-05&orientation=landscape',
    title: '月下奇谭',
    tag: '奇幻爱情',
    rating: '8.8',
    desc: '月色之下的人妖奇缘，唯美动人的东方奇幻故事',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 border border-accent-200 mb-4">
            <i className="ri-fire-line text-accent-600 text-sm"></i>
            <span className="text-xs font-medium text-accent-700 whitespace-nowrap">编辑推荐</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50">
            热门电影
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-200 max-w-lg mx-auto">
            本周最受影迷欢迎的高分电影，每一部都值得花时间
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.slice(0, 3).map((card, i) => (
            <a
              key={i}
              href="#ranking"
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-500/20 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <div className="w-full h-full">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-background-950/70 text-foreground-800 whitespace-nowrap backdrop-blur">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3 px-2 py-1 rounded-lg bg-accent-500 text-foreground-950 text-xs font-bold whitespace-nowrap">
                  {card.rating}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-50 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-200 line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
          {cards.slice(3).map((card, i) => (
            <a
              key={i + 3}
              href="#ranking"
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-500/20 transition-all duration-200 cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="relative w-full sm:w-[200px] aspect-[4/3] sm:aspect-auto overflow-hidden flex-shrink-0">
                <div className="w-full h-full">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-background-950/70 text-foreground-800 whitespace-nowrap backdrop-blur">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-2">
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-50 group-hover:text-primary-600 transition-colors">
                    {card.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded-md bg-accent-500 text-foreground-950 text-xs font-bold whitespace-nowrap">
                    {card.rating}
                  </span>
                </div>
                <p className="text-sm text-foreground-200">
                  {card.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}